module.exports = __webpack_public_path__ + "static/media/photo239.3a1551a0.jpg";